import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { PageResponse } from 'src/app/auth/base-capacitor-http';
import { Move, MovesService as MoveService, MoveStatus, MoveUpdateOption } from 'src/app/services/app/moves.service';
import { Yard, YardSearchParams, YardSearchType, YardService, YardStatus } from 'src/app/services/app/yard.service';
import { UtilitieService } from 'src/app/services/utils/utilities.service';
import { UpdateMessage, UpdateMessageType, WebsocketService } from 'src/app/services/utils/websocket.service';

@Component({
  selector: 'app-assign-moves',
  templateUrl: './assign-moves.component.html',
  styleUrls: ['./assign-moves.component.css'],
})
export class AssignMovesComponent implements OnInit {
  // entire yard list from here empty and taken yard spots are assigned.
  searchParams: YardSearchParams;
  page: PageResponse<Yard>;
  pageSizeOptions = [5, 10, 25];
  public openYardSpots: Yard[] = [];
  constructor(private moveService: MoveService, private yardService: YardService, private utilService: UtilitieService, private websocketService: WebsocketService) { }

  doNotAdd() {
    return false;
  }
  /**
   * This method is not required as the click drag functionality is not implemented
   * @param event 
   */

  /**
   * this allows the user to assign pending moves from the drop down form in the
   * take spot area. It sends back the pending move all that is left is to uupdate the
   * openYardSpots and the emptyYardSpots array accordingly nd add the move to the pending
   * moves list.
   * @param targetMove
   */
  async formAssignMove(endYardIndex: number, startYardIndex: number) {

    /**
* this ultimately does the same thing as the drop function
* only here the it's more straight forward.
*
* the move's starting position should never be empty.
* Likewise the ending position should always be empty.
*/
    const startYard: Yard = this.page.data[startYardIndex];
    const endYard: Yard = this.openYardSpots[endYardIndex];
    const targetMove: Move = {
      id: null,
      completed: null,
      created: new Date(),
      start: startYard,
      end: endYard,
      status: MoveStatus.PENDING,
      trailerId: startYard.trailerId,
      endYardId: endYard.id,
      startYardId: startYard.id

    }
    await this.moveService.updateMove(MoveUpdateOption.CREATE, targetMove, null);
    this.utilService.openSnackBar('Move has be added', 'Ok');
  }

  /**
   * This assigns a move individually. The id must be set along with the assign time
   * before getting sent to the db. In this case tahat data will be assigned on the
   * viewmodel level right before saving data to the db.
   * @param move
   */
  async assignMove(move: Move) {
    let result = await this.moveService.updateMove(MoveUpdateOption.CREATE, move, null);

    if (result) {
      this.utilService.openSnackBar('Assignment was succesfully added', '');
    } else {
      this.utilService.openSnackBar('There was an issue adding the assignment', 'Please try again');
    }

  }

  async handlePageEvent(e: PageEvent) {
    this.searchParams.size = e.pageSize;
    this.searchParams.page = e.pageIndex;
    this.searchYards();
  }

  async searchYards() {
    this.page = await this.yardService.searchYards(this.searchParams);
  }

  listenToUpdates() {
    this.websocketService.getUpdateMessages()
      .subscribe(update => {
        this.processUpdate(update)
      });
  }


  private processUpdate(update: UpdateMessage) {
    if (!update) return;

    switch (update.type) {
      case UpdateMessageType.MOVE:

        break;
      case UpdateMessageType.YARD:
        this.processYardUpdate(update);
        break;

    }

  }


  processYardUpdate(update: UpdateMessage) {

    let yard: Yard = JSON.parse(update.data);
    if (yard.status !== YardStatus.EMPTY) {
      let index: number = this.openYardSpots.findIndex(y => y.id === yard.id);
      if (index === -1) return;
      this.openYardSpots.splice(index, 1);
      return;
    }

    this.openYardSpots.push(yard);
  }

  async ngOnInit(): Promise<void> {
    this.utilService.updateLoading(true);

    this.page = new PageResponse();
    this.searchParams = {
      page: 0,
      size: 10,
      type: YardSearchType.STATUS,
      search: YardStatus.OCCUPIED
    }

    this.page = await this.yardService.searchYards(this.searchParams);
    this.openYardSpots = await this.yardService.getAllOpenYards();
    this.utilService.updateLoading(false);
  }

}
